import { ScheduleEntryState, Task, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

import { getScheduleDayTarget } from './get-schedule-day-target';
import { getScheduleByDate } from './schedules';

export type IsTaskCompletedOnDateOptions = {
  date?: Timestamp;
  today: Timestamp;
};

// Checkbox semantics (frequency-aware day target met), unlike `isHabitCompletedOnDay` (any progress).

export const isTaskCompletedOnDate = (
  task: Task,
  { date, today }: IsTaskCompletedOnDateOptions,
): boolean => {
  if (task.completedAt) {
    return true;
  }
  if (!task.schedules || !date) {
    return false;
  }

  const dateSchedule = getScheduleByDate(task.schedules, {
    date,
    today,
  });
  const entry = dateSchedule?.entries.find((entry) =>
    isSameDay(entry.date, date),
  );
  if (!entry) {
    return false;
  }

  const dayTarget = dateSchedule ? getScheduleDayTarget(dateSchedule) : 1;
  return (
    entry.state === ScheduleEntryState.Complete &&
    (entry.value ?? 0) >= dayTarget
  );
};
